// extracted by mini-css-extract-plugin
export default {"question":"profile-form-link_question__7Ccmz","link":"profile-form-link_link__NsQRV"};